import { Avatar, Card, CircularProgress, Grid, Hidden, Typography } from '@material-ui/core';
import DateRangeIcon from '@material-ui/icons/DateRange';
import randomColor, { ColorsDash } from '../color';

export const WipDashboardTechnician = ({ state, array, handleTechCalender, handleChangeByTime, handleTechOnClick, fromTechnicianDashboard }) => {
    const totalTechJobs = (array.selectedFilterTechData || []).reduce((acc, p) => acc + (Number(p?.total) || 0), 0);

    return (
        <>
            {' '}
            {state.showTechnicianLoader ? (
                <div className="wip-dash-Card" style={{ width: '100%', minHeight: '110px', display: 'flex' }}>
                    <CircularProgress className="wip-loader" />
                </div>
            ) : (
                <Card className="wip-dash-Card">
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
                        <Typography variant="h6" className="dashHeading">
                            Jobs By Technicians
                            <span className="dash-heading-total">( Total : {totalTechJobs} )</span>
                        </Typography>

                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    color: '#64748b',
                                    padding: '4px',
                                    borderRadius: '4px',
                                    border: '1px solid #cbd5e1',
                                    backgroundColor: '#f8fafc',
                                    transition: 'all 0.2s ease'
                                }}
                                title="Select Date"
                                onClick={() =>
                                    handleTechCalender({
                                        tid: '',
                                        bn: array.selectedValueByTech,
                                        name: '',
                                        bid: ''
                                    })
                                }
                            >
                                <DateRangeIcon fontSize="small" />
                            </div>
                        </div>
                    </div>

                    <hr className="hr-line" />

                    <div className="technicians-grid">
                        {array.selectedFilterTechData.length === 0 && (
                            <div style={{ gridColumn: '1 / -1' }}>
                                <span className="lableFont" style={{ color: '#94a3b8' }}>
                                    No technician data found
                                </span>
                            </div>
                        )}
                        {array.selectedFilterTechData.map((p, i) => {
                            const initial = p.name ? p.name.trim()[0].toUpperCase() : 'T';
                            const color = ColorsDash[i % ColorsDash.length] || '#183B68';
                            return (
                                <div key={p.name || i} className="tech-tile" onClick={() => handleTechOnClick(p)} title={p.name}>
                                    <Avatar
                                        className="tech-avatar"
                                        style={{
                                            backgroundColor: color
                                        }}
                                    >
                                        {initial}
                                    </Avatar>
                                    &nbsp;
                                    <div className="tech-info">
                                        <span className="lableFont" title={p.name}>
                                            {p.name}
                                        </span>
                                        <div className="valueFont">{p.total}</div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </Card>
            )}
        </>
    );
};
